// extracted by mini-css-extract-plugin
export default {"warningText":"WarningText_warningText__2fxpr"};